import { useState } from "react";
import { Languages, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const cache = new Map();

export function LineTranslation({ text, testId }) {
  const { user } = useAuth();
  const lang = user?.native_language;
  const key = `${lang}|${text}`;
  const [value, setValue] = useState(() => cache.get(key) || null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!lang) return null;

  const toggle = async () => {
    if (open) return setOpen(false);
    setOpen(true);
    if (value) return;
    setBusy(true);
    try {
      const { data } = await api.post("/translations/sentence", { text });
      cache.set(key, data.text);
      setValue(data.text);
    } catch (e) {
      toast.error(formatApiError(e));
      setOpen(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-1">
      <button onClick={toggle} data-testid={`${testId}-btn`} className="inline-flex items-center gap-1 text-xs font-bold text-sky-700 hover:text-sky-900">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Languages className="w-3.5 h-3.5" />}
        {open ? "Masquer" : "Traduire"}
      </button>
      {open && value && (
        <p dir={lang === "ar" ? "rtl" : "ltr"} data-testid={testId} className="mt-1 rounded-md bg-sky-100 text-sky-900 px-2 py-1 text-sm font-semibold">
          {value}
        </p>
      )}
    </div>
  );
}
